import type { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const LaptopIcon: React.FC<Props> = (props) => {
  return (
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-labelledby="titleId"
      {...props}
     aria-label="laptop icon">
      {/* <title>laptop icon</title> */}
      <path
        d="M18.325 13H1.675C1.30234 13 1 13.3038 1 13.675V14.125C1 15.4891 2.11009 16.6 3.475 16.6H16.525C17.8899 16.6 19 15.4899 19 14.125V13.675C19 13.3038 18.6991 13 18.325 13ZM16.525 15.25H3.475C2.93191 15.25 2.47712 14.8627 2.3725 14.35H17.6275C17.5234 14.8619 17.0678 15.25 16.525 15.25ZM4.15 5.575C4.15 5.45108 4.25108 5.35 4.375 5.35H15.625C15.7489 5.35 15.85 5.45108 15.85 5.575V12.1H17.2V5.575C17.2 4.70678 16.4941 4 15.625 4H4.375C3.50678 4 2.8 4.70678 2.8 5.575V12.1H4.15V5.575ZM11.2909 10.4744C11.4006 10.5841 11.5441 10.6375 11.6875 10.6375C11.8309 10.6375 11.9752 10.583 12.0852 10.4731L13.4352 9.12314C13.6549 8.90343 13.6549 8.54657 13.4352 8.32692L12.0852 6.97692C11.8655 6.75721 11.5095 6.75721 11.2898 6.97692C11.0702 7.19663 11.0701 7.55348 11.2898 7.77314L12.2421 8.72489L11.2898 9.67664C11.0687 9.89781 11.0687 10.255 11.2909 10.4744ZM8.70906 6.97844C8.48935 6.75872 8.13334 6.75872 7.91369 6.97844L6.56369 8.32844C6.34398 8.54815 6.34398 8.905 6.56369 9.12466L7.91369 10.4747C8.02563 10.5841 8.16906 10.6375 8.3125 10.6375C8.45594 10.6375 8.59937 10.5841 8.70906 10.4744C8.92877 10.2547 8.92877 9.89781 8.70906 9.67816L7.75844 8.725L8.70906 7.77437C8.90594 7.555 8.90594 7.19781 8.70906 6.97844Z"
        fill={props.fill || "currentColor"}
      />
    </svg>
  );
};

export default LaptopIcon;
